import { useRef } from "react";
import type { TouchEvent } from "react";

/**
 * Arrastar com o dedo para os lados nos carrosséis (pedido de 10/14: no celular só dava para usar os botões).
 * Só conta como arrasto se o movimento for mais horizontal que vertical, para não atrapalhar a rolagem da página.
 * `arrastou` fica true logo depois de um arrasto: use para ignorar o clique que alguns navegadores disparam em seguida.
 */
export function useSwipe(paraEsquerda: () => void, paraDireita: () => void, limiar = 40) {
  const x0 = useRef<number | null>(null);
  const y0 = useRef(0);
  const arrastou = useRef(false);

  const handlers = {
    onTouchStart: (e: TouchEvent) => {
      x0.current = e.touches[0].clientX;
      y0.current = e.touches[0].clientY;
      arrastou.current = false;
    },
    onTouchEnd: (e: TouchEvent) => {
      if (x0.current === null) return;
      const dx = e.changedTouches[0].clientX - x0.current;
      const dy = e.changedTouches[0].clientY - y0.current;
      x0.current = null;
      if (Math.abs(dx) < limiar || Math.abs(dx) < Math.abs(dy)) return;
      arrastou.current = true;
      if (dx < 0) paraEsquerda();
      else paraDireita();
    },
  };

  return { handlers, arrastou };
}
